export const SET_TRANSACTIONS = 'SET_TRANSACTIONS';
export const SET_PAGINATION = 'SET_PAGINATION';